export const SearchTypeMapping: { [index: string]: string } = {
  all: 'none',
  'skill-id': 'dropdown',
  'employee-name': 'keyword',
  mobile: 'keyword',
  email: 'keyword',
  'skill-category list': 'dropdown',
  'skill-name': 'keyword',
  skill_types: 'dropdown',
  resource_engaged: 'dropdown',
  profile_status: 'dropdown',
};
